import React, { Component } from 'react';

class Timer extends Component {
  constructor(props) {
    super(props);
    const seconds = this.props.seconds ? this.props.seconds : 0;
    this.state = {
      minutes: Math.floor(seconds / 60),
      seconds: seconds % 60,
    };
  }

  componentDidMount() {
    this.myInterval = setInterval(() => {
      const { seconds, minutes } = this.state;
      if (seconds > 0) {
        this.setState(({ seconds }) => ({
          seconds: seconds - 1,
        }));
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.myInterval);
        } else {
          this.setState(({ minutes }) => ({
            minutes: minutes - 1,
            seconds: 59,
          }));
        }
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  render() {
    const { minutes, seconds } = this.state;
    return (
      <span className="timer">
        {minutes === 0 && seconds === 0 ? (
          '0'
        ) : (
          <span>
            {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
          </span>
        )}
      </span>
    );
  }
}

export default Timer;
